import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { LabelModel, MODEL } from '@rxzu/angular';

@Component({
  selector: 'rxzu-risk-management-label',
  templateUrl: './risk-management-label.component.html',
  styleUrls: ['./risk-management-label.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RiskManagementLabelComponent implements OnInit {
  constructor(@Inject(MODEL) public model: LabelModel, private cdRef: ChangeDetectorRef) {}

  ngOnInit() {
    this.model.selectCoords().subscribe(() => {
      this.cdRef.detectChanges();
    });

    this.model
      .getParent()
      .selectHovered()
      .subscribe(() => {
        this.onHover();
      });

    this.model.setPainted(true);
  }

  onHover(): void {
    this.cdRef.detectChanges();
  }

  deleteLink(): void {
    const link = this.model.getParent();

    // TODO: Fix temportal to bug library
    this.model.setText('_trash');
    link.destroy();
    link.destroy();
  }
}
